var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMixing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.7267 5.1499H13.8667C9.44842 5.1499 5.8667 8.73162 5.8667 13.1499V55.01C5.8667 59.4283 9.44842 63.01 13.8667 63.01H55.7267C60.145 63.01 63.7267 59.4283 63.7267 55.01V13.1499C63.7267 8.73162 60.145 5.1499 55.7267 5.1499Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5865 0.0100098H8.72656C4.30828 0.0100098 0.726562 3.59173 0.726562 8.01001V49.8701C0.726562 54.2884 4.30828 57.8701 8.72656 57.8701H50.5865C55.0048 57.8701 58.5865 54.2884 58.5865 49.8701V8.01001C58.5865 3.59173 55.0048 0.0100098 50.5865 0.0100098Z",
    fill: "url(#paint0_linear_15_66)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2666 15.3101V26M17.2666 33V42.6001M31.2666 38.8301V42.6001M31.2666 15.3601V31.8301M45.2666 24.8301V42.6001M45.2666 15.3601V17.8301",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2666 32.95C19.1996 32.95 20.7666 31.3829 20.7666 29.45C20.7666 27.517 19.1996 25.95 17.2666 25.95C15.3336 25.95 13.7666 27.517 13.7666 29.45C13.7666 31.3829 15.3336 32.95 17.2666 32.95Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2566 24.78C47.1896 24.78 48.7566 23.213 48.7566 21.28C48.7566 19.347 47.1896 17.78 45.2566 17.78C43.3236 17.78 41.7566 19.347 41.7566 21.28C41.7566 23.213 43.3236 24.78 45.2566 24.78Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2666 38.78C33.1996 38.78 34.7666 37.213 34.7666 35.28C34.7666 33.347 33.1996 31.78 31.2666 31.78C29.3336 31.78 27.7666 33.347 27.7666 35.28C27.7666 37.213 29.3336 38.78 31.2666 38.78Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_66",
    x1: 3.06656,
    y1: 55.5201,
    x2: 56.2367,
    y2: 2.35013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixing);
export default __webpack_public_path__ + "static/media/mixing.36a633cc44881a87f4a19f7c45bc4ac7.svg";
export { ForwardRef as ReactComponent };